<nav class="navbar">
  <a href="" class="sidebar-toggler" (click)="toggleSidebar($event)">
    <i class="feather icon-menu"></i>
  </a>
  <div class="navbar-content">
    <ul class="navbar-nav">
      <li class="nav-item nav-profile" ngbDropdown *ngIf="user$ | async as _user">
        <a class="nav-link" ngbDropdownToggle id="profileDropdown">
          <div class="row">
            <div class="col"><img src="./assets/images/user.png" style="height: 40px;" /></div>
            <div class="col-auto">
              <p class="m-0">{{_user?.firstName}} {{_user?.lastName}}</p>
              <p class="m-0">{{_user?.username}}</p>
            </div>
          </div>
        </a>
        <div ngbDropdownMenu class="px-0" aria-labelledby="profileDropdown">
          <div class="d-flex flex-column align-items-center border-bottom px-5 py-3">
            <div class="mb-3">
              <img class="wd-80 ht-80 rounded-circle" src="/assets/images/user.png" alt="">
            </div>
            <div class="text-center">
              <p class="tx-16 fw-bolder">{{_user?.firstName}} {{_user?.lastName}}</p>
              <p *ngIf="_user?.department?.titleTh" class="tx-12 text-muted">{{_user?.department?.titleTh}}</p>
              <p *ngIf="_user?.division?.titleTh" class="tx-12 text-muted">{{_user?.division?.titleTh}}</p>
              <p *ngIf="_user?.organization?.titleTh" class="tx-12 text-muted">{{_user?.organization?.titleTh}}</p>
            </div>
          </div>
          <ul class="list-unstyled p-1 border-bottom" *ngIf="userRoleMapping$ | async as _userRoleMapping">
            <li class="p-2" *ngFor="let role of _userRoleMapping">
              <a (click)="role !== currentRole && onSelectRole(role)"
                 class="d-flex ms-0 btn-like"
                 [class.active]="role === currentRole">
                <i class="feather icon-user me-2 icon-md"></i> <span>{{ role?.permissionGroup?.title }}</span>
              </a>
            </li>
          </ul>
          <ul class="list-unstyled p-1">
            <li class="dropdown-item py-2">
              <a href="" (click)="onLogout($event)" class="d-flex text-body ms-0">
                <i class="feather icon-log-out me-2 icon-md"></i>
                <span>ออกจากระบบ</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
      <!--<li class="nav-item nav-profile" ngbDropdown>
    <a class="nav-link" ngbDropdownToggle id="profileDropdown">
      <img class="wd-30 ht-30 rounded-circle" src="https://via.placeholder.com/30x30" alt="profile">
    </a>
    <div ngbDropdownMenu class="px-0" aria-labelledby="profileDropdown">
      <div class="d-flex flex-column align-items-center border-bottom px-5 py-3">
        <div class="mb-3">
          <img class="wd-80 ht-80 rounded-circle" src="https://via.placeholder.com/80x80" alt="">
        </div>
        <div class="text-center">
          <p class="tx-16 fw-bolder">Amiah Burton</p>
          <p class="tx-12 text-muted">amiahburton@gmail.com</p>
        </div>
      </div>
      <ul class="list-unstyled p-1">
        <li class="dropdown-item py-2">
          <a routerLink="/general/profile" class="d-flex text-body ms-0">
            <i class="feather icon-user me-2 icon-md"></i>
            <span>Profile</span>
          </a>
        </li>
        <li class="dropdown-item py-2">
          <a href="" (click)="false" class="d-flex text-body ms-0">
            <i class="feather icon-edit me-2 icon-md"></i>
            <span>Edit Profile</span>
          </a>
        </li>
        <li class="dropdown-item py-2">
          <a href="" (click)="false" class="d-flex text-body ms-0">
            <i class="feather icon-repeat me-2 icon-md"></i>
            <span>Switch User</span>
          </a>
        </li>
        <li class="dropdown-item py-2">
          <a href="" (click)="onLogout($event)" class="d-flex text-body ms-0">
            <i class="feather icon-log-out me-2 icon-md"></i>
            <span>Log Out</span>
          </a>
        </li>
      </ul>
    </div>
  </li>-->
    </ul>
  </div>
</nav>
